import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { applyManaCursors } from "./lib/applyManaCursors";
import {
  isInformationRoute,
  pathnameToOverlayRoute,
} from "./lib/overlayRoutes";
import "./index.css";

applyManaCursors();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const initialRoute = pathnameToOverlayRoute(window.location.pathname);

async function renderApplication() {
  if (isInformationRoute(initialRoute)) {
    const { default: InformationApp } = await import("./InformationApp");

    createRoot(rootElement).render(
      <StrictMode>
        <InformationApp route={initialRoute} />
      </StrictMode>,
    );
    return;
  }

  const { default: App } = await import("./App");

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void renderApplication();
